import React from "react";
import { useParams } from "react-router-dom";
import ScheduleVisitComponent from "./components/ScheduleVisitComponent";

export default function ScheduleVisit() {
    const {scheduleId} = useParams();
    return (
        <ScheduleVisitComponent scheduleId={scheduleId}/>
    )
}